import ProcedureDTO from '@src/adapters/dto/procedure/ProcedureDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {}

interface Result {
  items: ProcedureDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/procedure/for_selection/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindProceduresForSelection = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindProceduresForSelectionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindProceduresForSelection;
